var path = '/templates/projects.reports/report_graph.html';
var html = "<section ng-if=chartConfig.series[0].data.length><h1>{{ 'projectsReports.reportGraph.kakutoku_uriage_suii' | translate }}</h1><highchart config=chartConfig></highchart></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.reports/report_graph.html
// module id = 1476
// module chunks = 0